export default __webpack_public_path__ + "static/media/default.7cae3126.svg";